(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    const pageHeight = window.innerHeight;
    const backToTopButton = document.getElementById('back-to-top');

    function checkVisibleBackToTop() {
        let y = window.scrollY;
        if (y > window.innerHeight) {
            backToTopButton.classList.add('back-to-top--active');
        } else {
            backToTopButton.classList.remove('back-to-top--active');
        }
    }

    function backToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }

    window.addEventListener('scroll', checkVisibleBackToTop);
    window.backToTop = backToTop;

    const formsInView = new Set();
    const formObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            entry.isIntersecting ? formsInView.add(entry.target) : formsInView.delete(entry.target);
        });
        document.documentElement.classList.toggle('hs-form-in-view', formsInView.size > 0);
    });

    document.querySelectorAll('.hs-form-card').forEach((form) => formObserver.observe(form));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartItemRemoveButton extends HTMLElement {
        constructor() {
            super();

            this.addEventListener('click', (event) => {
                event.preventDefault();
                const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
                cartItems.updateQuantity(this.dataset.index, 0, event);
            });
        }
    }

    if (!customElements.get('cart-item-remove-button')) {
        customElements.define('cart-item-remove-button', CartItemRemoveButton);
    }

    if (!customElements.get('cart-drawer-items')) {
        class CartDrawerItems extends HTMLElement {
            cartUpdateUnsubscriber = undefined;
            cartClearUnsubscriber = undefined;

            constructor() {
                super();

                const debouncedOnChange = debounce((event) => {
                    this.onChange(event);
                }, window.ON_CHANGE_DEBOUNCE_TIMER);

                this.addEventListener('change', (event) => {
                    this.setUpdating(true);
                    debouncedOnChange(event);
                });
            }

            setUpdating(updating) {
                const cartDrawer = this.closest('cart-drawer');
                if (!cartDrawer) {
                    return;
                }

                cartDrawer.classList.toggle('is-updating', updating);
                cartDrawer.querySelectorAll('[name="checkout"]').forEach((button) => {
                    button.toggleAttribute('aria-disabled', updating);
                });
                cartDrawer.querySelectorAll('.sidebar__footer__rows').forEach((rows) => {
                    rows.setAttribute('aria-busy', updating);
                });
            }

            connectedCallback() {
                this.cartUpdateUnsubscriber = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
                    if (event.source === 'cart-items') {
                        return;
                    }
                    return this.onCartUpdate();
                });

                this.cartClearUnsubscriber = window.subscribe(window.PUB_SUB_EVENTS.cartClear, () => {
                    this.onCartUpdate();
                });
            }

            disconnectedCallback() {
                if (this.cartUpdateUnsubscriber) {
                    this.cartUpdateUnsubscriber();
                }
            }

            getSectionsToRender() {
                return [
                    // {
                    //     id: 'cart-drawer',
                    //     section: 'cart-drawer',
                    //     selector: '.sidebar__content'
                    // },
                    // {
                    //     id: 'cart-drawer',
                    //     section: 'cart-drawer',
                    //     selector: '.sidebar__footer--m'
                    // },
                    {
                        id: 'cart-drawer',
                        section: 'cart-drawer',
                        selector: '.sidebar__footer.sidebar__footer--d'
                    },
                    {
                        id: 'cart-drawer',
                        section: 'cart-drawer',
                        selector: '.sidebar__footer.sidebar__footer--m'
                    },
                    {
                        id: 'cart-drawer',
                        section: 'cart-drawer',
                        selector: '.sidebar__wrapper cart-drawer-items'
                    },
                    {
                        id: 'open-cart-drawer',
                        section: 'cart-bubble',
                        selector: '[data-open-card-drawer] .header__nav__action__indicator'
                    },
                    {
                        id: 'open-cart-drawer--mobile',
                        section: 'cart-bubble',
                        selector: '[data-open-card-drawer] .header__nav__action__indicator'
                    }
                ];
            }

            resetQuantityInput(id) {
                const input = this.querySelector(`#Quantity-${id}`) || this.querySelector(`#Drawer-quantity-${id}`);
                input.value = input.getAttribute('value');
                this.isEnterPressed = false;
            }

            setValidity(event, index, message) {
                this.setUpdating(false);
                event.target.setCustomValidity(message);
                event.target.reportValidity();
                this.resetQuantityInput(index);
                event.target.select();
            }

            validateQuantity(event) {
                const inputValue = parseInt(event.target.value);
                const index = event.target.dataset.index;

                let message = '';

                if (inputValue < event.target.dataset.min) {
                    message = window.translate.cart.quantity_error_min.replace('[quantity]', event.target.dataset.min);
                } else if (inputValue > parseInt(event.target.max)) {
                    const maxTemplate = parseInt(event.target.max) === 1 ? window.translate.cart.quantity_error_max_one : window.translate.cart.quantity_error_max;
                    message = maxTemplate.replace('[quantity]', event.target.max);
                } else if (inputValue % parseInt(event.target.step) !== 0) {
                    message = window.translate.cart.quantity_error.replace('[quantity]', event.target.step);
                }

                if (message) {
                    this.setValidity(event, index, message);
                } else {
                    event.target.setCustomValidity('');
                    event.target.reportValidity();
                    this.updateQuantity(
                        index,
                        inputValue,
                        event,
                        document.activeElement.getAttribute('name'),
                        event.target.dataset.quantityVariantId
                    );
                }
            }

            onChange(event) {
                this.validateQuantity(event);
            }

            onCartUpdate() {
                if (this.tagName === 'CART-DRAWER-ITEMS') {
                    return fetch(`${Shopify.routes.root}cart?section_id=cart-drawer`)
                        .then((response) => response.text())
                        .then((responseText) => {
                            const html = new DOMParser().parseFromString(responseText, 'text/html');
                            const selectors = [
                                'cart-drawer-items',
                                '#cart-drawer .sidebar__footer--d',
                                '#cart-drawer .sidebar__footer--m',
                            ];

                            // if (!this.drawer.open) {
                            selectors.push('#cart-drawer .sidebar__additional');
                            // }

                            for (const selector of selectors) {
                                const targetElement = document.querySelector(selector);
                                const sourceElement = html.querySelector(selector);
                                if (targetElement && sourceElement) {
                                    targetElement.replaceWith(sourceElement);
                                }
                            }

                            // document.querySelector('cart-drawer').fetchRecommended();
                        })
                        .catch((e) => {
                            console.error(e);
                        });
                } else {
                    console.log("this.tagName not 'CART-DRAWER-ITEMS'", this.tagName);

                    /* TODO: Review (case for cart page) */
                    /*                return fetch(`${Shopify.routes.root}cart?section_id=main-cart-items`)
                                        .then((response) => response.text())
                                        .then((responseText) => {
                                            const html = new DOMParser().parseFromString(responseText, 'text/html');
                                            const sourceQty = html.querySelector('cart-items');
                                            this.innerHTML = sourceQty.innerHTML;
                                        })
                                        .catch((e) => {
                                            console.error(e);
                                        });*/
                }
            }

            updateQuantity(line, quantity, event, name, variantId) {
                const eventTarget = event.currentTarget instanceof CartItemRemoveButton ? 'clear' : 'change';
                const cartPerformanceUpdateMarker = CartPerformance.createStartingMarker(`${eventTarget}:user-action`);

                this.enableLoading(line);

                const body = JSON.stringify({
                    line,
                    quantity,
                    sections: this.getSectionsToRender().map((section) => section.section),
                    sections_url: window.location.pathname,
                });

                fetch(`${Shopify.routes.root}cart/change.json`, { ...fetchConfig(), ...{ body } })
                    .then((response) => {
                        return response.json();
                    })
                    .then((parsedState) => {
                        // const parsedState = JSON.parse(state);

                        CartPerformance.measure(`${eventTarget}:paint-updated-sections`, () => {
                            /* TODO: Review */
                            const quantityElement =
                                document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
                            const items = document.querySelectorAll('.cart-item');

                            if (parsedState.errors) {
                                quantityElement.value = quantityElement.getAttribute('value');
                                // this.updateLiveRegions(line, parsedState.errors);
                                this.updateLiveRegions(parsedState.errors);
                                return;
                            }

                            this.classList.toggle('is-empty', parsedState.item_count === 0);
                            const cartDrawerWrapper = document.querySelector('cart-drawer');
                            // const cartFooter = document.getElementById('main-cart-footer');
                            // if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                            if (cartDrawerWrapper) {
                                cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
                                cartDrawerWrapper
                                    .querySelector('[data-clear-all]')
                                    ?.classList.toggle('hidden', parsedState.item_count === 0);
                            }

                            const sectionsToRender = this.getSectionsToRender();
                            if (parsedState.item_count === 0) {
                                sectionsToRender.push({
                                    id: 'cart-drawer',
                                    section: 'cart-drawer',
                                    selector: '.sidebar__additional'
                                });
                            }

                            sectionsToRender.forEach((section) => {
                                const elementToReplace =
                                    document.getElementById(section.id).querySelector(section.selector);

                                if (!elementToReplace) {
                                    return;
                                }

                                elementToReplace.innerHTML = window.getSectionInnerHTML(
                                    parsedState.sections[section.section],
                                    section.selector
                                );
                            });
                            /*                        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
                                                    let message = '';
                                                    if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
                                                        if (typeof updatedValue === 'undefined') {
                                                            message = window.translate.cart.error;
                                                        // } else {
                                                        //     message = window.translate.cart.quantity_error_max.replace('[quantity]', updatedValue);
                                                        }
                                                    }*/
                            // this.updateLiveRegions(line, message);
                            // this.updateLiveRegions(parsedState.item_count ? message : '');
                            this.updateLiveRegions('');

                            /*TODO: Review class names*/
                            // const lineItem =
                            //     document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                            // if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                            //     cartDrawerWrapper
                            //         ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                            //         : lineItem.querySelector(`[name="${name}"]`).focus();
                            // } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                            //     trapFocus(cartDrawerWrapper.querySelector('.sidebar__additional__content'), cartDrawerWrapper.querySelector('a'));
                            // } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                            //     trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
                            // }
                        });

                        publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
                    })
                    .catch((err) => {
                        console.error(err);
                        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
                        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
                        errors.textContent = window.translate.cart.error;
                    })
                    .finally(() => {
                        this.disableLoading(line);
                        CartPerformance.measureFromMarker(`${eventTarget}:user-action`, cartPerformanceUpdateMarker);
                    });
            }

            // updateLiveRegions(line, message) {
            updateLiveRegions(message) {
                // const lineItemError =
                //     document.getElementById(`Item-error-${line}`) || document.getElementById(`CartDrawer-ItemError-${line}`);
                // if (lineItemError) {
                //     if (message) {
                //         lineItemError.classList.remove('hidden');
                //     } else {
                //         lineItemError.classList.add('hidden');
                //     }
                //     lineItemError.querySelector('.cart__item__error__text').textContent = message;
                // }
                document.querySelectorAll('.sidebar__footer__message').forEach(el => {
                    el.classList.toggle('hidden', !message);
                    el.innerHTML = message;
                });
            }
            //
            // getSectionInnerHTML(html, selector) {
            //     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
            // }

            enableLoading(line) {
                this.setUpdating(true);

                const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
                mainCartItems.classList.add('cart__items--disabled');

                const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
                const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

                [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

                document.activeElement.blur();
            }

            disableLoading(line) {
                this.setUpdating(false);

                /* TODO: Review */
                const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
                if (mainCartItems) {
                    mainCartItems.classList.remove('cart__items--disabled');
                }

                const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
                const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

                cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
                cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
            }
        }
        customElements.define('cart-drawer-items', CartDrawerItems);
    }

    if (!customElements.get('cart-drawer')) {
        class CartDrawer extends HTMLElement {
            constructor() {
                super();

                this.attachShadow({ mode: 'open' });
                this.shadowRoot.innerHTML = `<div class="dialog-wrapper"><slot></slot></div>`;

                this.wrapper = this.shadowRoot.querySelector('.dialog-wrapper');
            }

            // Children are read here, not in the constructor: a clone or a renderer can construct the
            // element before its <dialog> exists, which used to throw on this.drawer.addEventListener.
            initDrawer() {
                if (this.drawer) {
                    return true;
                }

                const drawer = this.querySelector('dialog');
                if (!drawer) {
                    return false;
                }

                this.drawer = drawer;

                this.openDrawerEls = document.querySelectorAll('[data-open-card-drawer]');
                this.closeDrawerEls = this.querySelectorAll('[data-close-drawer]');

                this.productDrawerAdditionalContent = this.querySelector('.sidebar__additional__content');
                this.additionalItems = [];

                // Totals are stale while a quantity change is in flight, so don't go to checkout yet
                this.addEventListener('submit', (e) => {
                    if (this.classList.contains('is-updating')) {
                        e.preventDefault();
                    }
                }, true);

                this.clearAllButton = this.querySelector('[data-clear-all]');
                this.clearAllButton?.addEventListener('click', (e) => {
                    this.clearAll();
                });

                // this.open = this.open.bind(this);
                // this.close = this.close.bind(this);

                this.drawer.addEventListener('click', (e) => {
                    if (e.target === this.drawer) {
                        this.close();
                    }
                });

                this.openDrawerEls.forEach((el) => {
                    el.addEventListener('click', () => {
                        document.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
                        this.open();
                    });
                });

                this.closeDrawerEls.forEach((el) => {
                    el.addEventListener('click', () => {
                        this.close();
                    });
                });

                this.addEventListener('keyup', (e) => e.code === 'Escape' && this.close());

                return true;
            }

            connectedCallback() {
                if (!this.initDrawer() && document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', () => this.initDrawer(), { once: true });
                }
            }

            getSectionsToRender() {
                return [
                  {
                  id: 'cart-drawer',
                  section: 'cart-drawer',
                  selector: '.sidebar__footer sidebar__footer--d'
                },
                {
                    id: 'cart-drawer',
                    section: 'cart-drawer',
                    selector: '.sidebar__footer sidebar__footer--m'
                },
                {
                    id: 'open-cart-drawer',
                    section: 'cart-bubble',
                    selector: '[data-open-card-drawer] .header__nav__action__indicator'
                },{
                    id: 'open-cart-drawer--mobile',
                    section: 'cart-bubble',
                    selector: '[data-open-card-drawer] .header__nav__action__indicator'
                }];
            }
            // setActiveElement(element) {
            //     this.activeElement = element;
            // }
            clearAll() {
                fetch(`${Shopify.routes.root}cart/clear.js`, { ...fetchConfig() })
                    .then((response) => {
                        return response.json();
                    })
                    .then(() => {
                        window.publish(window.PUB_SUB_EVENTS.cartClear);
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.clearAllButton.classList.add('hidden');
                        setTimeout(() => this.classList.add('is-empty'), 500);
                    });
            }
            renderContents(parsedState) {
                this.querySelector('.sidebar__additional__content').classList.contains('sidebar__additional__content--empty') &&
                this.querySelector('.sidebar__additional__content').classList.remove('sidebar__additional__content--empty');
                this.productId = parsedState.id;
                this.getSectionsToRender().forEach((section) => {
                    const sectionElement = section.selector
                        ? document.querySelector(section.selector)
                        : document.getElementById(section.id);

                    if (!sectionElement) return;
                    sectionElement.innerHTML = window.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
                });

                setTimeout(() => {
                    // this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
                    this.open.apply(this);
                });
            }
            close() {
                if (!this.drawer) {
                    return;
                }

                this.wrapper.style.display = 'none';
                this.drawer.close();
                this.drawer.classList.remove('sidebar--with-additional');
            }
            open() {
                if (!this.initDrawer()) {
                    return;
                }

                this.wrapper.style.display = 'block';
                this.clearErrorMessage();
                if (!this.drawer.open) this.drawer.showModal();
                this.drawer.focus({preventScroll: false});
                this.fetchRecommended();
                this.drawer.classList.add('sidebar--with-additional');
                this.clearAllButton.classList.toggle('hidden', this.classList.contains('is-empty'));
            }
            clearErrorMessage() {
                document.querySelectorAll('.sidebar__footer__message').forEach(el => {
                    el.classList.toggle('hidden', true);
                    el.innerHTML = '';
                });
            }
            fetchRecommended() {
                const firstItemEl = this.querySelector('.cart__item');

                if (firstItemEl) {
                    this.productDrawerAdditionalContent = this.querySelector('.sidebar__additional__content');
                    const additionalTemplate = document.getElementById('drawer-additional-item-template');

                    const productId = firstItemEl.dataset.productId;

                    fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=4&intent=related`)
                        .then(response => {
                            return response.json();
                        })
                        .then(({products}) => {
                            this.productDrawerAdditionalContent.innerHTML = '';

                            for (let idx = 0; idx < products.length; idx++) {
                                const product = products[idx];

                                let firstAvailableVariant = undefined;
                                let firstAvailableVariantId = "";
                                if (product.variants && product.variants.length > 0) {
                                    firstAvailableVariant = product.variants.find(v => v.available);
                                    if (firstAvailableVariant) {
                                        firstAvailableVariantId = firstAvailableVariant.id;
                                    }
                                }

                                const clone = additionalTemplate.content.cloneNode(true);
                                const additionalItem = clone.querySelector('.sidebar__additional__item');
                                additionalItem.dataset.productId = product.id;

                                const itemImage = additionalItem.querySelector('.item__image');
                                itemImage.href = product.url;

                                const image = additionalItem.querySelector('.item__image img');
                                const imageSrc = firstAvailableVariant?.featured_image?.src ?? product.featured_image;
                                if (imageSrc) {
                                    image.src = imageSrc;
                                }
                                image.alt = product.title;

                                const title = additionalItem.querySelector('.item__info__name');
                                title.innerHTML = product.title;
                                title.href = product.url;

                                const designer = additionalItem.querySelector('.item__info__designer');
                                designer.innerHTML = decodeURIComponent(product.vendor);

                                const price = additionalItem.querySelector('.item__info__price');

                                if (firstAvailableVariant.compare_at_price > firstAvailableVariant.price) {
                                    price.innerHTML = `<div class="item__info__price__row">
                                      <del>${formatMoney(firstAvailableVariant.compare_at_price)}</del>
                                      <ins>${formatMoney(firstAvailableVariant.price)}</ins>
                                    </div>`;
                                } else {
                                    price.innerHTML = formatMoney(firstAvailableVariant.price);
                                }

                                /* TODO: Enable after fix */
/*                                const variants = additionalItem.querySelector('.item__variants');
                                if (product.variants) {
                                    for (const variant of product.variants) {
                                        if (variant.options) {
                                            for (const option of variant.options) {
                                                if (option.color) {
                                                    variants.innerHTML +=  `<button type="button" class="item__variant ${firstAvailableVariantId === variant.id ? 'item__variant--active' :''}" style="background-color: ${option.color}" data-variant-id="${variant.id}" data-variant-image="${variant.featured_image.src}"></button>`
                                                }
                                            }
                                        }
                                    }
                                }*/

                                const additionalItemQuickAddForm = clone.querySelector('product-form');
                                additionalItemQuickAddForm.dataset.productTitle = product.title;

                                const additionalItemQuickAddFormId = additionalItemQuickAddForm.querySelector('[name="id"]');
                                additionalItemQuickAddFormId.value = firstAvailableVariantId;

                                const additionalItemQuickAddFormProductId = additionalItemQuickAddForm.querySelector('[name="product-id"]');
                                additionalItemQuickAddFormProductId.value = product.id;

                                this.additionalItems.push(product);
                                this.productDrawerAdditionalContent.appendChild(clone);
                                this.productDrawerAdditionalContent.classList.remove('sidebar__additional__content--empty');
                            }
                        });
                }
            }
        }
        customElements.define('cart-drawer', CartDrawer);
    }

    if (!customElements.get('free-shipping-amount')) {
        class FreeShippingAmount extends HTMLElement {
            constructor() {
                super();

                this.titleEl = this.querySelector('.shipping__title');
                this.amountEl = this.querySelector('.shipping__amount');
            }

            connectedCallback() {
                // Shipping is calculated by ShipX at checkout (per brand, country and volume).
                // The drawer no longer estimates it, so it never shows a different amount
                // from the one charged at checkout (updated 2026-10-05).
                this.titleEl.innerHTML = this.dataset.delivery;
                this.amountEl.innerHTML = this.dataset.deliveryCheckout;
                this.amountEl.classList.remove('hidden');
            }
        }

        customElements.define('free-shipping-amount', FreeShippingAmount);
    }

    document.addEventListener('DOMContentLoaded', () => {
        if (window.location.hash.includes('cart')) {
            const cartOpenEl = document.querySelector('[data-open-card-drawer]');
            if (cartOpenEl) {
                cartOpenEl.click();
            }
        }
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-notification"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-notification')) {
        class CartNotification extends HTMLElement {
            /* Narrowest panel that fits the 62px image, two lines of title and two buttons in a row. */
            static MIN_WIDTH = 290;
            static GAP_BELOW_HEADER = 16;

            cartUpdateUnsubscriber = undefined;
            closeTimer = undefined;

            constructor() {
                super();

                this.onResize = () => !this.classList.contains('hidden');

                this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
                this.querySelectorAll('[data-cart-notification-close]').forEach(el => {
                    el.addEventListener('click', () => {
                    document.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
                      this.close();
                    });
                });
            }

            connectedCallback() {
                this.cartUpdateUnsubscriber = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
                    if (event.source === 'cart-items') {
                        return;
                    }

                    /* cart/add.js answers with the added line item (or { items } for multi-add).
                       A failed add publishes only refreshed sections — nothing was added, so stay closed. */
                    const data = event.cartData || {};
                    const item = Array.isArray(data.items) ? data.items[0] : data;
                    if (!item || !item.variant_id) {
                        return;
                    }

                    this.renderItem(item);

                    return this.getCartDetails().then((cart) => this.open(cart));
                });

                window.addEventListener('resize', this.onResize);
            }

            async getCartDetails() {
              try {
                const response = await fetch(`${window.Shopify.routes.root}cart.js`);
                const cart = await response.json();
                return cart;
              } catch (error) {
                console.error("Error fetching cart details:", error);
              }
            }

            disconnectedCallback() {
                if (this.cartUpdateUnsubscriber) {
                    this.cartUpdateUnsubscriber();
                }
                window.removeEventListener('resize', this.onResize);
                clearTimeout(this.closeTimer);
            }

            renderItem(item) {
                const image = this.querySelector('.cart-notification__item__image');
                const src = item.featured_image?.url || item.image;
                if (src) {
                    const url = new URL(src, window.location.origin);
                    url.searchParams.set('width', '124');
                    image.src = url.toString();
                    image.alt = item.featured_image?.alt || item.product_title || '';
                }
                image.hidden = !src;

                this.querySelector('.cart-notification__item__name').textContent = item.product_title || item.title || '';
                this.querySelector('.cart-notification__item__option').textContent =
                    item.product_has_only_default_variant ? '' : (item.variant_title || '');
                this.querySelector('.cart-notification__item__price').innerHTML = formatMoney(item.final_price);
                this.querySelector('.cart-notification__item').classList.remove('hidden');
            }

            renderSummary(cart) {
                const summary = this.querySelector('.cart-notification__summary');
                if (!cart || typeof cart.item_count !== 'number') {
                    summary.classList.add('hidden');
                    return;
                }

                const template = cart.item_count === 1 ? this.dataset.countOne : this.dataset.countOther;
                summary.querySelector('.cart-notification__summary__count').textContent =
                    template.replace('[n]', cart.item_count);
                summary.querySelector('.cart-notification__summary__total').innerHTML = formatMoney(cart.total_price);
                summary.classList.remove('hidden');
            }

            open(cart) {
                this.renderSummary(cart);
                this.classList.remove('hidden');

                clearTimeout(this.closeTimer);
                this.closeTimer = setTimeout(this.close.bind(this), 5000);
            }

            close() {
                clearTimeout(this.closeTimer);
                this.classList.add('hidden');
            }
        }

        customElements.define('cart-notification', CartNotification);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-home-seo-box"] && !Shopify.designMode) return;
  try {
    const readMoreButtons = document.querySelectorAll('.marketing__text__more');

if (readMoreButtons.length) {
function onClickReadMoreButton(e) {
const button = e.currentTarget;
const container = button.closest('.marketing__text');

if (container) {
container.classList.toggle('marketing__text--opened');
}
}

readMoreButtons.forEach((el) => el.addEventListener('click', onClickReadMoreButton));
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-hub-seo-box"] && !Shopify.designMode) return;
  try {
    const readMoreButtons = document.querySelectorAll('.marketing__text__more');

if (readMoreButtons.length) {
function onClickReadMoreButton(e) {
const button = e.currentTarget;
const container = button.closest('.marketing__text');

if (container) {
container.classList.toggle('marketing__text--opened');
}
}

readMoreButtons.forEach((el) => el.addEventListener('click', onClickReadMoreButton));
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card')) {
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        //this.variantsSwitch = this.querySelectorAll('.product-card__variant--color');
        this.image = this.querySelector('.product-card__image img');
        this.emptyPlaceholder = '\u00A0';
        this.normalizeSku = (value) => {
          if (value === null || value === undefined || value === '' || value === 'null') {
            return this.emptyPlaceholder;
          }

          return value;
        };

        //this.querySelectorAll('.product-card__variant--color').forEach(variantSwitch => {
        // // console.log("variantSwitch", variantSwitch);
        //variantSwitch.addEventListener('click', (el) => this.switchVariant(el.target));
        //});

        this.addEventListener('mouseenter', (e) => {
          const variantsSlider = this.querySelector('.scroll-snap-slider');
          const prevBtn = this.querySelector('.swatches-nav__prev');
          const nextBtn = this.querySelector('.swatches-nav__next');

          if (!variantsSlider) {
            return;
          }

          if (variantsSlider.scrollWidth > variantsSlider.clientWidth) {
            prevBtn.classList.remove('hidden');
            nextBtn.classList.remove('hidden');
          } else {
            prevBtn.classList.add('hidden');
            nextBtn.classList.add('hidden');
          }
        });

        this.querySelectorAll('.ts-option').forEach((option) => {
          option.addEventListener('mouseenter', (e) => {
            const currentImageUrl = e.target.dataset.url;
            const currentSku = e.target.dataset.sku;
            const currentPrice = e.target.dataset.price;
            const compareAtPrice = e.target.dataset.compareAtPrice;
            const saleBadgeValue = e.target.dataset.saleBadgeValue;
            const leadTime = e.target.dataset.leadTime;
            const quantityWithDeliveryStatus = e.target.dataset.quantityWithDeliveryStatus;
            const quantityWithDelivery = e.target.dataset.quantityWithDelivery;
            // const currentQty = e.target.dataset.quantity;
            const currentVariantAvailability = e.target.dataset.available;
            let variantId = this.querySelector('product-form [name="id"]') || false;
            let btn = this.querySelector('product-form .buy-button') || false;
            let qtyWithDeliveryItemEls = this.querySelectorAll('.product-card__info__delivery__item');
            let qtyWithDeliveryEls = this.querySelectorAll('.product-card__info__delivery__item span');
            // let qty_parent = this.querySelector('.inventory-policy') || false;
            // let shipping_info = this.querySelector('.shipping__rule') || false;
            let badge = this.querySelector('.product-card__image__top') || false;

            this.querySelector(`.ts-option.active`).classList.remove('active');
            e.target.classList.add('active');
            this.showVariantImage(currentImageUrl);
            // this.querySelector(".ts-options__sku").innerText = currentSku;

            const mtoButton = this.querySelector('[data-open-mto-drawer]');
            if (mtoButton) {
              mtoButton.dataset.variantSku = e.target.dataset.sku;
              mtoButton.dataset.productTitle = e.target.dataset.title;
            }

            this.syncAddToProjectVariant(e.target.dataset);

            /* TODO: Check */
            let finishPrice = currentPrice;
            if (compareAtPrice && compareAtPrice !== currentPrice) {
              this.querySelectorAll('.product-card__info__price del').forEach((el) => (el.innerHTML = compareAtPrice));
              this.querySelectorAll('.product-card__info__price del').forEach((el) => el.classList.remove('hidden'));

              if (badge && saleBadgeValue && badge.querySelectorAll('.product-card__badge--sale').length === 0) {
                badge.insertAdjacentHTML(
                  'afterbegin',
                  `<span class="product-card__badge product-card__badge--sale">${saleBadgeValue}</span>`
                );
              } else if (badge) {
                badge.insertAdjacentHTML(
                'afterbegin',
                `<span>&nbsp;</span>`
                );
              }

              finishPrice = compareAtPrice;
            } else {
              this.querySelectorAll('.product-card__info__price del').forEach((el) => el.classList.add('hidden'));

              if (badge) {
                badge.querySelectorAll('.product-card__badge--sale').forEach((el) => badge.removeChild(el));
              }
            }

            this.querySelectorAll('.product-card__info__price ins').forEach((el) => (el.innerHTML = currentPrice));
            this.querySelectorAll('.product-card__info__sku').forEach((el) => {
              el.innerHTML = this.normalizeSku(currentSku);
            });

            if (btn) {
              const btnText = btn.querySelector('[data-text]');
              //const btnPrice = btn.querySelector('[data-price]');

              if (currentVariantAvailability == 'false') {
                btn.setAttribute('disabled', 'disabled');
                btnText.textContent = window.translate.product.buy_button.sold_out;
              } else {
                btn.removeAttribute('disabled');
                btnText.textContent = window.translate.product.buy_button.add_to_cart;
                //btnPrice.dataset.price = currentPrice;
                //btnPrice.innerHTML = ` - ${currentPrice}`;
              }
              btn.dataset.productId = e.target.dataset.variantId;
            }

            if (variantId) {
              variantId.value = e.target.dataset.variantId;
            }

            for (let qtyWithDeliveryEl of qtyWithDeliveryEls) {
              if (leadTime) {
                qtyWithDeliveryEl.innerHTML = leadTime;
              } else {
                qtyWithDeliveryEl.innerHTML = quantityWithDelivery;
              }
            }

            for (let qtyWithDeliveryItemEl of qtyWithDeliveryItemEls) {
              qtyWithDeliveryItemEl.classList.remove('product-card__info__delivery__item--stock');
              qtyWithDeliveryItemEl.classList.remove('product-card__info__delivery__item--soon');
              qtyWithDeliveryItemEl.classList.remove('product-card__info__delivery__item--out');
              qtyWithDeliveryItemEl.classList.add(`product-card__info__delivery__item--${quantityWithDeliveryStatus}`);
            }
          });

          option.addEventListener('touchstart', (e) => {
            e.preventDefault();
            const currentImageUrl = e.target.dataset.url;
            const currentSku = e.target.dataset.sku;
            this.querySelector(`.ts-option.active`).classList.remove('active');
            e.target.classList.add('active');
            this.showVariantImage(currentImageUrl);
            // this.querySelector(".ts-options__sku").innerText = currentSku;

            this.syncAddToProjectVariant(e.target.dataset);
          });
        });
      }

      /**
       *  Activates the card image for a swatch, creating it on first use. Only the first
       *  variant's <img> is rendered server-side; the rest are built from the swatch's
       *  data-url with the same CDN sizes the Liquid template uses.
       */
      showVariantImage(url) {
        if (!url) {
          return;
        }

        const images = this.querySelectorAll('.product-card__image__featured');
        let image = this.querySelector(`.product-card__image__featured[data-url="${url}"]`);

        if (!image && images.length) {
          const separator = url.includes('?') ? '&' : '?';
          image = images[0].cloneNode(false);
          image.classList.remove('active');
          image.removeAttribute('fetchpriority');
          image.removeAttribute('style');
          image.loading = 'eager';
          image.decoding = 'async';
          image.dataset.url = url;
          image.srcset = `${url}${separator}width=342 342w, ${url}${separator}height=440 352w, ${url}${separator}height=720 576w`;
          image.src = `${url}${separator}height=720`;
          images[images.length - 1].after(image);
        }

        if (!image) {
          return;
        }

        this.querySelector('.product-card__image__featured.active')?.classList.remove('active');
        image.classList.add('active');
      }

      /**
       *  Keeps the card's "add to project" button pointed at the selected swatch.
       *
       *  The button reads data-variant-id when it posts to the portal. On the product page the
       *  element follows the variantChange event instead, but a card switches variants locally
       *  and never publishes that event, so the attribute has to be written here.
       */
      syncAddToProjectVariant(dataset) {
        if (!dataset.variantId) {
          return;
        }

        const addToProject = this.querySelector('add-to-project[data-variant-id]');
        if (addToProject) {
          addToProject.dataset.variantId = dataset.variantId;
          addToProject.dataset.sku = dataset.sku;
          addToProject.dataset.variantTitle = dataset.variantTitle;
          addToProject.dataset.price = dataset.priceRaw;
        }
      }

      connectedCallback() {
        const openProductDrawerEls = this.querySelector('[data-open-product-drawer]');
        const productDrawer = document.querySelector('product-drawer');

        if (openProductDrawerEls) {
          openProductDrawerEls.addEventListener('click', (e) => {
            e.preventDefault();
            productDrawer.open(openProductDrawerEls);
          });
        }

        const badge3d = this.querySelector('.product-card__badge--3d[data-open-model-url]');

        if (badge3d) {
          const openModel = (event) => {
            // The badge is nested inside the card's product-image <a>. preventDefault stops that
            // anchor navigating to the bare product URL, which is what left the 3D viewer closed.
            event.preventDefault();
            event.stopPropagation();

            const url = new URL(badge3d.dataset.openModelUrl, window.location.origin);
            url.searchParams.set('open-3d', '1');
            window.location.href = url.toString();
          };

          badge3d.addEventListener('click', openModel);

          badge3d.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              openModel(event);
            }
          });
        }
        // this.classList.add('buttons_added');
      }

      // TODO: Remove
      switchVariant(variantSwitch) {
        this.image.src = variantSwitch.dataset.variantImage;

        const oldVariant = this.querySelector('.product-card__variant--active');
        oldVariant.classList.remove('product-card__variant--active');

        variantSwitch.classList.add('product-card__variant--active');

        /* TODO: Implement update quick view*/
        /* const quickAdd = item.querySelector('.item__info__quick-add'); */
        /* quickAdd.dataset.variantId = el.dataset.variantId; */
      }
    }

    customElements.define('product-card', ProductCard);
  }

  if (!customElements.get('swatch-slider')) {
    class SwatchesSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = null;
        this.slides = null;
        this.prevBtn = null;
        this.nextBtn = null;
        this.slideWidth = 0;
      }

      connectedCallback() {
        this.slider = this.querySelector('.scroll-snap-slider');
        this.slides = this.querySelectorAll('.ts-option');
        this.prevBtn = this.querySelector('.swatches-nav__prev');
        this.nextBtn = this.querySelector('.swatches-nav__next');

        if (this.slider && this.slides.length > 0 && this.prevBtn && this.nextBtn) {
          this.addEventListeners();
        }
      }

      addEventListeners() {
        this.nextBtn.addEventListener('click', () => {
          this.slideWidth = this.slides[0].clientWidth;

          this.slider.scrollBy({
            left: this.slideWidth,
            behavior: 'smooth',
          });
        });

        this.prevBtn.addEventListener('click', () => {
          this.slideWidth = this.slides[0].clientWidth;

          this.slider.scrollBy({
            left: -this.slideWidth,
            behavior: 'smooth',
          });
        });
      }
    }

    customElements.define('swatch-slider', SwatchesSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-slider')) {
    class ProductSlider extends HTMLElement {
      constructor() {
        super();

        this.init();
      }

      init() {
        this.slidesContainer = this.querySelector('.product__slider__slides');
        this.prevButton = this.querySelector('.product__slider__prev');
        this.nextButton = this.querySelector('.product__slider__next');
        this.dotsEls = this.querySelectorAll('.product__slider__dot');
        this.zoomButton = this.querySelector('.product__slider__zoom');
        this.slideTop = this.querySelector('.product__slider__slide__top');

        this.slides = this.querySelectorAll('.product__slider__slide');

        const observerOptions = {
          root: this.slidesContainer,
          rootMargin: '-10px',
          threshold: 0.6,
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.dotsEls.forEach((dot) => {
                dot.classList.remove('product__slider__dot--active');
              });

              this.dotsEls.forEach((dot) => {
                if (dot.dataset.index === entry.target.dataset.index) {
                  if (this.zoomButton) {
                    this.zoomButton.dataset.index = entry.target.dataset.index;
                  }
                  dot.classList.add('product__slider__dot--active');
                }
              });
            }
          });
        }, observerOptions);

        this.slides.forEach((slideEl) => {
          observer.observe(slideEl);
        });

        this.scrollToInitialMedia();

        if (this.prevButton) {
          this.prevButton.addEventListener('click', this.prevSlide.bind(this));
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.nextSlide.bind(this));
        }

        if (this.zoomButton) {
          this.zoomButton.addEventListener('click', () => {
            if (this.lightbox) {
              this.querySelector(`.product__slider__slide[data-index="${this.zoomButton.dataset.index}"]`).click();
            }
          });
        }

        this.dotsEls.forEach((dotEl) => {
          dotEl.addEventListener('click', () => {
            const media = this.querySelector(`.product__slider__slide[data-index='${dotEl.dataset.index}']`);
            media.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        });

        if (this.dataset.zoomable) {
          this.initLightbox();
        } else {
          this.slides.forEach((el) => {
            el.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              return false;
            });
          });
        }

        // Delegated, so this also covers the badge product-drawer.liquid creates on the fly when a
        // quick view switches product. Bound unconditionally rather than only under `zoomable`:
        // on the product page open3DModel() opens in place, and in the drawer (which has no
        // lightbox) it returns false and we navigate to the product page instead.
        //
        // Capture phase is required: the non-zoomable branch above binds a stopPropagation handler
        // on every slide, which would swallow a bubble-phase delegate before it ever reached us.
        //
        // ASCII ONLY in this block. Shopify's asset bundler counts characters but writes bytes, so
        // each multi-byte character truncates the tail of the compiled snippet-scripts.js by the
        // difference. Two em-dashes here cut the closing sequence down to a bare brace, which broke
        // parsing of the entire bundle and silently unregistered every custom element on the site.
        this.addEventListener(
          'click',
          (event) => {
            const badge = event.target.closest('.product__slider__badge--3d');
            if (badge) {
              this.activate3DModel(event, badge);
            }
          },
          true
        );

        this.arButton = this.querySelector('.product__slider__ar');
        this.arDialog = this.querySelector('.product__slider__ar-dialog');
        if (this.arButton && this.arDialog) {
          this.arButton.addEventListener('click', this.openArDialog.bind(this));
          this.arDialog
            .querySelector('.product__slider__ar-dialog__close')
            .addEventListener('click', () => this.arDialog.close());
        }

        this.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') {
              return;
            }
            const badge = event.target.closest('.product__slider__badge--3d');
            if (badge) {
              this.activate3DModel(event, badge);
            }
          },
          true
        );
      }

      activate3DModel(event, badge) {
        event.preventDefault();
        event.stopPropagation();

        if (this.open3DModel()) {
          return;
        }

        const target = badge.dataset.openModelUrl;
        if (!target) {
          return;
        }

        const url = new URL(decodeURIComponent(target), window.location.origin);
        url.searchParams.set('open-3d', '1');
        window.location.href = url.toString();
      }

      // The QR points back at this page with the current variant, asking the scanning phone to
      // open the 3D view and start AR (see openRequested3DModel and the model contentLoad hook).
      async openArDialog() {
        const qrEl = this.arDialog.querySelector('.product__slider__ar-dialog__qr');
        const arUrl = new URL(window.location.href);
        arUrl.hash = '';
        arUrl.searchParams.set('open-3d', '1');
        arUrl.searchParams.set('ar', '1');

        if (!this.arDialog.open) this.arDialog.showModal();

        if (qrEl.dataset.url === arUrl.toString()) {
          return;
        }

        try {
          await ProductSlider.loadQrLibrary(this.arButton.dataset.qrScriptUrl);
        } catch (error) {
          console.error(error);
          return;
        }

        const qr = qrcode(0, 'M');
        qr.addData(arUrl.toString());
        qr.make();
        qrEl.innerHTML = qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
        qrEl.dataset.url = arUrl.toString();
      }

      // Loaded on first use only: the encoder is ~55 KB and most visitors never open the dialog.
      static loadQrLibrary(src) {
        if (!ProductSlider.qrLibraryPromise) {
          ProductSlider.qrLibraryPromise = new Promise((resolve, reject) => {
            if (window.qrcode) {
              resolve();
              return;
            }
            const script = document.createElement('script');
            script.src = src;
            script.onload = () => {
              window.qrcode.stringToBytes = window.qrcode.stringToBytesFuncs['UTF-8'];
              resolve();
            };
            script.onerror = () => {
              ProductSlider.qrLibraryPromise = null;
              reject(new Error('QR code library failed to load'));
            };
            document.head.appendChild(script);
          });
        }
        return ProductSlider.qrLibraryPromise;
      }

      open3DModel({ requestUrl } = {}) {
        if (this.getClientRects().length === 0) {
          return false;
        }

        const modelSlide = this.querySelector('.product__slider__slide[data-model]');
        if (!modelSlide || !this.lightbox) {
          return false;
        }

        const slideIndex = Number(modelSlide.dataset.index || 0);
        if (requestUrl) {
          this.arRequested = requestUrl.searchParams.get('ar') === '1';
          requestUrl.searchParams.delete('open-3d');
          requestUrl.searchParams.delete('ar');
          const nextUrl = `${requestUrl.pathname}${requestUrl.search}${requestUrl.hash}`;
          window.history.replaceState({}, '', nextUrl);
        }

        requestAnimationFrame(() => {
          this.slidesContainer.scrollLeft = modelSlide.offsetLeft;

          if (this.zoomButton) {
            this.zoomButton.dataset.index = slideIndex;
          }

          this.dotsEls.forEach((dot) => {
            dot.classList.toggle('product__slider__dot--active', dot.dataset.index === String(slideIndex));
          });

          this.lightbox.loadAndOpen(
            slideIndex,
            { gallery: this.slidesContainer },
            {
              x: window.innerWidth / 2,
              y: window.innerHeight / 2,
            }
          );
        });

        return true;
      }

      openRequested3DModel() {
        const requestUrl = new URL(window.location.href);
        if (requestUrl.searchParams.get('open-3d') !== '1') {
          return;
        }

        this.open3DModel({ requestUrl });
      }

      initLightbox() {
        // photoswipe*.js load from <head> and can fail on a bad connection. Without them there is
        // no zoom: the slides stay plain links to the product page, and this.lightbox stays unset.
        if (typeof PhotoSwipeLightbox === 'undefined' || typeof PhotoSwipe === 'undefined') return;

        const lightbox = new PhotoSwipeLightbox({
          bgOpacity: 1,
          mainClass: 'pswp--custom-bg',
          gallery: '.product__slider__slides',
          children: 'a.product__slider__slide',
          pswpModule: () => PhotoSwipe,
          clickToCloseNonZoomable: false,
          closeOnVerticalDrag: false,

          /* TODO: Translate */
          closeTitle: 'Close the dialog',
          zoomTitle: 'Zoom the photo',
          arrowPrevTitle: 'Go to the previous photo',
          arrowNextTitle: 'Go to the next photo',
          errorMsg: 'The photo cannot be loaded',
        });

        this.lightbox = lightbox;

        // Same note the page shows above the gallery, repeated in the full screen view where the
        // product image is largest and reads most like a promise. Cloned from the rendered element
        // so the copy and its contact link stay defined once, in the locale files.
        const disclaimerEl = (this.closest('product-info') || document).querySelector(
          '.product__media-disclaimer'
        );
        if (disclaimerEl) {
          const disclaimerHtml = disclaimerEl.innerHTML;

          lightbox.on('uiRegister', () => {
            lightbox.pswp.ui.registerElement({
              name: 'media-disclaimer',
              order: 9,
              isButton: false,
              appendTo: 'root',
              html: disclaimerHtml,
            });
          });
        }

        lightbox.on('pointerDown', (e) => {
          if (e.originalEvent.target.tagName === 'MODEL-VIEWER') {
            e.preventDefault();
          }
        });
        lightbox.addFilter('itemData', (itemData, index) => {
          if (!itemData.element || !itemData.element.dataset) {
            return itemData;
          }

          const model = itemData.element.dataset.model;
          if (model) {
            itemData.id = itemData.element.dataset.id;
            itemData.model = model;
          }

          const modelGlb = itemData.element.dataset.modelGlb;
          if (modelGlb) {
            itemData.modelGlb = modelGlb;
          }

          const modelUsdz = itemData.element.dataset.modelUsdz;
          if (modelUsdz) {
            itemData.modelUsdz = modelUsdz;
          }

          const video = itemData.element.dataset.video;
          if (video) {
            itemData.video = video;
            itemData.videoType = itemData.element.dataset.videoType;
          }

          return itemData;
        });
        lightbox.on('contentLoad', (e) => {
          const { content } = e;
          if (content.type === 'model') {
            e.preventDefault();

            content.element = document.createElement('div');
            content.element.className = 'pswp__model-container';

            const modelViewer = document.createElement('model-viewer');
            //modelViewer.src = content.data.src;
            modelViewer.src = content.data.modelGlb;
            modelViewer.setAttribute('ios-src', content.data.modelUsdz);
            modelViewer.setAttribute('auto-rotate', 'true');
            modelViewer.setAttribute('rotation-per-second', '20deg');
            modelViewer.setAttribute('camera-controls', 'true');
            modelViewer.setAttribute('quick-look-browsers', 'safari chrome');
            modelViewer.setAttribute('xr-environment', 'true');
            modelViewer.setAttribute('ar', 'true');
            modelViewer.setAttribute('ar-placement', 'floor'); // TODO: Change for wall item)s
            modelViewer.setAttribute('ar-modes', 'quick-look scene-viewer webxr');
            modelViewer.setAttribute('ar-scale', 'fixed');
            modelViewer.setAttribute('ar-status', 'not-presenting');
            modelViewer.setAttribute('style', '--poster-color: transparent');
            modelViewer.setAttribute('data-shopify-feature', '1.12');
            modelViewer.setAttribute('data-js-focus-visible', '');
            content.element.appendChild(modelViewer);

            // Arrived from the desktop AR QR code: go straight into AR once the model is ready.
            // Some browsers refuse to launch AR without a user gesture; then the AR button
            // model-viewer shows on the opened model is one tap away.
            if (this.arRequested) {
              this.arRequested = false;
              modelViewer.addEventListener(
                'load',
                () => {
                  if (modelViewer.canActivateAR) {
                    Promise.resolve(modelViewer.activateAR()).catch(() => {});
                  }
                },
                { once: true }
              );
            }

            // const activateARButtonEl = document.createElement('button');
            // activateARButtonEl.setAttribute('type', 'button');
            // activateARButtonEl.setAttribute('slot', 'ar-button');
            // activateARButtonEl.setAttribute('style', 'background-color: #1b1c1b; color: #fff; border-radius: 4px; border-width: 1px; border-style: solid; position: absolute; bottom: 16px; right: 16px; padding: 4px;');
            // activateARButtonEl.style.backgroundColor = 'white';
            // activateARButtonEl.style.borderRadius = '4px';
            // activateARButtonEl.innerText = 'Activate AR';
            // modelViewer.appendChild(activateARButtonEl);

            // content.element = content.productModel;
          } else if (content.type === 'video') {
            e.preventDefault();

            content.element = document.createElement('video');
            content.element.className = 'pswp__video-container';
            content.element.setAttribute('playsinline', 'playsinline');
            content.element.setAttribute('preload', 'metadata');
            content.element.setAttribute('autoplay', 'autoplay');
            content.element.setAttribute('muted', 'muted');
            content.element.setAttribute('controls', 'controls');

            const source = document.createElement('source');
            source.src = content.data.video;
            source.type = content.data.videoType;
            content.element.appendChild(source);

            const img = document.createElement('img');
            img.src = content.data.msrc;
            content.element.appendChild(img);
          } else if (content.type === 'external-video') {
            e.preventDefault();

            content.element = document.createElement('div');
            content.element.className = 'pswp__external-video-container';

            const iframe = document.createElement('iframe');
            iframe.src = content.data.video;
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
            iframe.setAttribute('allowfullscreen', 'allowfullscreen');
            content.element.appendChild(iframe);
          }
        });
        lightbox.init();
        this.openRequested3DModel();
      }

      // A ?variant= link must open on that variant's image, not the product's first one.
      // Scrolls only the slides track so the page itself stays at the top.
      scrollToInitialMedia() {
        const mediaId = this.dataset.initialMediaId;
        if (!mediaId || !this.slidesContainer) {
          return;
        }

        const slide = this.slidesContainer.querySelector(`.product__slider__slide[data-media-id='${mediaId}']`);
        if (!slide || slide === this.slides[0]) {
          return;
        }

        const offset = slide.getBoundingClientRect().left - this.slidesContainer.getBoundingClientRect().left;
        this.slidesContainer.scrollTo({ left: this.slidesContainer.scrollLeft + offset, behavior: 'instant' });
      }

      prevSlide() {
        let newScrollLeft = this.slidesContainer.scrollLeft - this.slides[0].offsetWidth;
        if (newScrollLeft <= 0) {
          newScrollLeft = this.slidesContainer.scrollWidth;
        }
        this.slidesContainer.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
      }

      nextSlide() {
        let newScrollLeft = this.slidesContainer.scrollLeft + this.slides[0].offsetWidth;
        if (newScrollLeft >= this.slidesContainer.scrollWidth) {
          newScrollLeft = 0;
        }
        this.slidesContainer.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
      }
    }

    customElements.define('product-slider', ProductSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["range-slider-inputs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('range-slider-inputs')) {
        class RangeSliderInputs extends HTMLElement {
            debounceTimer;

            constructor() {
                super();

                this.rangeMin = this.querySelector('.range-min');
                this.rangeMax = this.querySelector('.range-max');
                this.inputMin = this.querySelector('.input-min');
                this.inputMax = this.querySelector('.input-max');
                this.hiddenInputMin = this.querySelector('.hidden-input-min');
                this.hiddenInputMax = this.querySelector('.hidden-input-max');
                this.track = this.querySelector('.slider-track');

                this.minGap = 1;
            }

            connectedCallback() {
                this.updateTrack();
                this.setupListeners();
            }

            setupListeners() {
                this.rangeMin.oninput = () => {
                    if (parseInt(this.rangeMax.value) - parseInt(this.rangeMin.value) <= this.minGap) {
                        this.rangeMin.value = parseInt(this.rangeMax.value) - this.minGap;
                    }
                    this.inputMin.value = this.rangeMin.value;
                    this.updateTrack();
                    this.handleDebounce();
               };

                this.rangeMax.oninput = () => {
                    if (parseInt(this.rangeMax.value) - parseInt(this.rangeMin.value) <= this.minGap) {
                        this.rangeMax.value = parseInt(this.rangeMin.value) + this.minGap;
                    }
                    this.inputMax.value = this.rangeMax.value;
                    this.updateTrack();
                    this.handleDebounce();
               };

                this.inputMin.onchange = () => {
                    this.rangeMin.value = this.inputMin.value;
                    this.rangeMin.oninput();
                };

                this.inputMax.onchange = () => {
                    this.rangeMax.value = this.inputMax.value;
                    this.rangeMax.oninput();
                };
            }

            handleDebounce() {
              if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
              }
              this.debounceTimer = setTimeout(() => {
                this.hiddenInputMin.value = this.inputMin.value;
                this.hiddenInputMax.value = this.inputMax.value;

                const inputEvent = new Event('input', {
                  target: this.hiddenInputMin,
                  bubbles: true,
                  cancelable: true
                });

                this.hiddenInputMin.dispatchEvent(inputEvent);
              }, 600);
            }

            updateTrack() {
                const minVal = parseInt(this.rangeMin.value);
                const maxVal = parseInt(this.rangeMax.value);
                const maxLimit = this.rangeMin.max;

                const percentLeft = (minVal / maxLimit) * 100;
                const percentRight = 100 - (maxVal / maxLimit) * 100;

                this.track.style.background = `linear-gradient(to right, #e0e0e0 ${percentLeft}%, #000 ${percentLeft}%, #000 ${100 - percentRight}%, #e0e0e0 ${100 - percentRight}%)`;
            }

        }

        customElements.define('range-slider-inputs', RangeSliderInputs);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["range-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('range-slider')) {
        class RangeSlider extends HTMLElement {
            constructor() {
                super();

                this.minRange = this.querySelector('.min-range');
                this.maxRange = this.querySelector('.max-range');
                this.minValueDisplay = this.querySelector('.min-value');
                this.maxValueDisplay = this.querySelector('.max-value');
                this.rangeFill = this.querySelector('.range-fill');
                this.isMoney = Boolean(this.dataset.isMoney);
                this.minMax = parseInt(this.minRange.max);
            }

            connectedCallback() {
                this.updateSlider();
                this.setupListeners();
            }

            setupListeners() {
                this.minRange.addEventListener('input', this.updateSlider.bind(this));
                this.maxRange.addEventListener('input', this.updateSlider.bind(this));

                this.minRange.style.zIndex = '4';
                this.maxRange.style.zIndex = '4';
            }

            updateSlider() {
                let minVal = parseInt(this.minRange.value);
                let maxVal = parseInt(this.maxRange.value);

                if (minVal >= maxVal) {
                    this.minRange.value = maxVal - 1;
                    minVal = maxVal - 1;
                }

                this.minValueDisplay.innerHTML = this.isMoney ? formatMoney(minVal * 100) : minVal;
                this.maxValueDisplay.innerHTML = this.isMoney ? formatMoney(maxVal * 100) : maxVal;

                const minPercent = (minVal / this.minMax) * 100;
                const maxPercent = (maxVal / this.minMax) * 100;

                this.rangeFill.style.left = `${minPercent}%`;
                this.rangeFill.style.width = `${maxPercent - minPercent}%`;
            }

        }

        customElements.define('range-slider', RangeSlider);
    }

/*
    document.addEventListener('DOMContentLoaded', function() {
        const rangeSliderEls = document.querySelectorAll('.range-slider-container');
        rangeSliderEls.forEach(function(rangeSliderEl) {
            const minRange = rangeSliderEl.querySelector('.min-range');
            const maxRange = rangeSliderEl.querySelector('.max-range');
            const minValueDisplay = rangeSliderEl.querySelector('.min-value');
            const maxValueDisplay = rangeSliderEl.querySelector('.max-value');
            const rangeFill = rangeSliderEl.querySelector('.range-fill');
            const isMoney = Boolean(rangeSliderEl.dataset.isMoney);

            const minMax = parseInt(minRange.max);

            function updateSlider() {
                let minVal = parseInt(minRange.value);
                let maxVal = parseInt(maxRange.value);

                if (minVal >= maxVal) {
                    minRange.value = maxVal - 1;
                    minVal = maxVal - 1;
                }

                minValueDisplay.innerHTML = isMoney ? formatMoney(minVal * 100) : minVal;
                maxValueDisplay.innerHTML = isMoney ? formatMoney(maxVal * 100) : maxVal;

                const minPercent = (minVal / minMax) * 100;
                const maxPercent = (maxVal / minMax) * 100;

                rangeFill.style.left = `${minPercent}%`;
                rangeFill.style.width = `${maxPercent - minPercent}%`;
            }

            const setupListeners = function () {
                minRange.addEventListener('input', updateSlider);
                maxRange.addEventListener('input', updateSlider);

                minRange.style.zIndex = '4';
                maxRange.style.zIndex = '4';
            };

            updateSlider();
            setupListeners();
        });
    });
*/
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["seo-block"] && !Shopify.designMode) return;
  try {
    const readMoreButtons = document.querySelectorAll('.marketing__text__more');

  if (readMoreButtons.length) {
    function onClickReadMoreButton(e) {
      const button = e.currentTarget;
      const container = button.closest('.marketing__text');

      if (container) {
        container.classList.toggle('marketing__text--opened');
      }
    }

    readMoreButtons.forEach((el) => el.addEventListener('click', onClickReadMoreButton));
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["show-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('show-more-button')) {
        customElements.define(
            'show-more-button',
            class ShowMoreButton extends HTMLElement {
                constructor() {
                    super();
                    const button = this.querySelector('button');
                    button.addEventListener('click', (event) => {
                        this.expandShowMore(event);
                        const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
                        if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
                            nextElementToFocus.querySelector('input').focus();
                        }
                    });
                }
                expandShowMore(event) {
                    const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
                    this.querySelector('.show-more__label').classList.toggle('show-more__label--opened');
                    parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
                }
            }
        );
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vc-scroll-container"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!customElements.get('vc-scroll-container')) {
      class VcScrollContainer extends HTMLElement {
        constructor() {
          super();

          this.handleScroll = this.updateButtons.bind(this);
          this.handleResize = this.scheduleUpdate.bind(this);
          this.handleMutation = this.scheduleUpdate.bind(this);
          this.handlePrevClick = () => this.scrollItems(-1);
          this.handleNextClick = () => this.scrollItems(1);
        }

        connectedCallback() {
          this.viewportEl = this.querySelector('[data-vc-scroll-viewport]');
          this.navEl = this.querySelector('[data-vc-scroll-nav]');
          this.prevButton = this.querySelector('[data-vc-scroll-prev]');
          this.nextButton = this.querySelector('[data-vc-scroll-next]');

          if (!this.viewportEl || !this.navEl || !this.prevButton || !this.nextButton) {
            return;
          }

          this.prevButton.addEventListener('click', this.handlePrevClick);
          this.nextButton.addEventListener('click', this.handleNextClick);
          this.viewportEl.addEventListener('scroll', this.handleScroll, { passive: true });
          window.addEventListener('resize', this.handleResize);

          this.mutationObserver = new MutationObserver(this.handleMutation);
          this.mutationObserver.observe(this.viewportEl, { childList: true });

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(this.handleResize);
            this.resizeObserver.observe(this);
            this.resizeObserver.observe(this.viewportEl);
          }

          this.scheduleUpdate();
        }

        disconnectedCallback() {
          this.prevButton?.removeEventListener('click', this.handlePrevClick);
          this.nextButton?.removeEventListener('click', this.handleNextClick);
          this.viewportEl?.removeEventListener('scroll', this.handleScroll);
          window.removeEventListener('resize', this.handleResize);

          if (this.mutationObserver) {
            this.mutationObserver.disconnect();
          }

          if (this.resizeObserver) {
            this.resizeObserver.disconnect();
          }

          if (this.frameRequest) {
            window.cancelAnimationFrame(this.frameRequest);
            this.frameRequest = null;
          }
        }

        scheduleUpdate() {
          if (this.frameRequest) {
            window.cancelAnimationFrame(this.frameRequest);
          }

          this.frameRequest = window.requestAnimationFrame(() => {
            this.frameRequest = null;
            this.updateNavigation();
          });
        }

        getStepMultiplier() {
          return Math.max(1, parseInt(this.dataset.vcScrollStep || 1, 10));
        }

        getItems() {
          if (!this.viewportEl) {
            return [];
          }

          return [...this.viewportEl.children].filter((item) => item instanceof HTMLElement);
        }

        getCurrentIndex(items, viewportRect) {
          const index = items.findIndex((item) => item.getBoundingClientRect().left >= viewportRect.left - 1);

          if (index !== -1) {
            return index;
          }

          return Math.max(items.length - 1, 0);
        }

        getScrollTarget(direction) {
          const items = this.getItems();
          const viewportRect = this.viewportEl?.getBoundingClientRect();

          if (!items.length || !viewportRect) {
            return null;
          }

          const stepMultiplier = this.getStepMultiplier();
          const currentIndex = this.getCurrentIndex(items, viewportRect);
          const targetIndex =
            direction > 0
              ? Math.min(currentIndex + stepMultiplier, items.length - 1)
              : Math.max(currentIndex - stepMultiplier, 0);
          const maxScrollLeft = this.viewportEl.scrollWidth - this.viewportEl.clientWidth;

          return Math.min(items[targetIndex].offsetLeft, maxScrollLeft);
        }

        scrollItems(direction) {
          const targetLeft = this.getScrollTarget(direction);

          if (targetLeft === null) {
            return;
          }

          this.viewportEl.scrollTo({
            left: targetLeft,
            behavior: 'smooth',
          });
        }

        updateNavigation() {
          if (!this.viewportEl || !this.navEl || !this.prevButton || !this.nextButton) {
            return;
          }

          const hasOverflow = this.viewportEl.scrollWidth > this.viewportEl.clientWidth + 1;
          this.navEl.hidden = !hasOverflow;

          if (!hasOverflow) {
            this.prevButton.disabled = true;
            this.nextButton.disabled = true;
            return;
          }

          this.updateButtons();
        }

        updateButtons() {
          if (!this.viewportEl || !this.prevButton || !this.nextButton) {
            return;
          }

          const maxScrollLeft = this.viewportEl.scrollWidth - this.viewportEl.clientWidth;
          const currentScrollLeft = this.viewportEl.scrollLeft;

          this.prevButton.disabled = currentScrollLeft <= 1;
          this.nextButton.disabled = currentScrollLeft >= maxScrollLeft - 1;
        }
      }

      customElements.define('vc-scroll-container', VcScrollContainer);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
